import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import OperationLogs from '../../../shared/OperationLogs/OperationLogs';
import { changeLogsDetails, getOperationLogs } from '../../../../redux/actions/logs';
import { LOGS_OPERATION_NAMES, LOGS_PAGINATION_SIZE } from '../../../../utils/constants';
import LogsService from '../../../../services/LogsService';
import useTicketInformationLogsColumns from '../columns/use-ticket-information-logs-columns';

import styles from '../TicketIformation.module.scss';

const Logs = props => {
    const { ticketCode } = props;

    const dispatch = useDispatch();

    const offset = useSelector(state => state.pagination.operationLogs?.offset) || 0;

    const columns = useTicketInformationLogsColumns();

    const queryForExport = {
        operation: LOGS_OPERATION_NAMES.paymentBlockUnblock,
        offset: 0,
        limit: LOGS_PAGINATION_SIZE + offset,
    };

    const onViewLogsClick = () => {
        dispatch(
            changeLogsDetails({
                operationLogsDrawerVisibility: true,
                logsDetails: { operation: LOGS_OPERATION_NAMES.paymentBlockUnblock },
                fetchData: LogsService.getOperationLogs,
            })
        );
        dispatch(
            getOperationLogs({
                fetchData: LogsService.getOperationLogs,
                query: {
                    operation: LOGS_OPERATION_NAMES.paymentBlockUnblock,
                    offset: 0,
                    limit: LOGS_PAGINATION_SIZE,
                    ticketCode,
                },
            })
        );
    };

    return (
        <>
            <InfoCircleOutlined className={styles.settlementInfo} onClick={onViewLogsClick} />
            <OperationLogs
                columns={columns}
                query={queryForExport}
                exportedFileName={'Ticket Information Logs'}
                exportable={false}
            />
        </>
    );
};

export default Logs;
